import { useAppContainerStyle, useFirebaseAnalytics } from '@/shared/hooks'
import { useAppStore } from '@/shared/store'
import { useEffect, useState } from 'react'
import { refreshInterval } from '@/shared/constants'
import { getApiService } from '@/api/getApiService'
import { getUseFavoritesHook } from '@/shared/getContainer/getUseFavoritesHook'
import {
    getFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import { getConfigHook } from '@/shared/getContainer/getConfigHook'
import { getGetFetchBootstrapsModule } from '@/shared/getContainer/getGetFetchBootstrapsModule'

const fetchBootstraps = await getGetFetchBootstrapsModule()
const useFavoritesChannels = await getUseFavoritesHook()
const useConfig = await getConfigHook()

const loginApi = getApiService()

export const useApp = () => {
    const appContainerStyle = useAppContainerStyle()
    const token: string | null = getFromLocalStorage(sessionTokenLsKeyword)
    const [isTokenInStorage, setIsTokenInStorage] = useState(!!token)
    const { isUserLoggedIn, actualProfile } = useAppStore()

    const { isSkinSet, takeConfigIfNeed } = useConfig()

    const authenticateAndFetchConfig = async () => {
        if (!isTokenInStorage) {
            const token = getFromLocalStorage(sessionTokenLsKeyword)
            if (token) {
                setIsTokenInStorage(true)
            }
        }

        if (isTokenInStorage) {
            await takeConfigIfNeed()
        }
    }

    const { analyticsLogEvent } = useFirebaseAnalytics()

    analyticsLogEvent('start_app')
    const analyticsMethods = {
        analyticsLogEvent,
    }

    const { getFavoritesChannels } = useFavoritesChannels()

    useEffect(() => {
        const interval = setInterval(async () => {
            loginApi.refreshAccessToken()
        }, refreshInterval)

        const handleAsyncFunctions = async () => {
            await authenticateAndFetchConfig()
            await getFavoritesChannels()
        }

        handleAsyncFunctions()

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        if (actualProfile?.id) {
            const handleAsyncFunctions = async () => {
                await getFavoritesChannels()
            }

            handleAsyncFunctions()
        }
    }, [actualProfile?.id])

    useEffect(() => {
        const handleAsyncFunctions = async () => {
            await authenticateAndFetchConfig()

            if (fetchBootstraps) {
                await fetchBootstraps()
            }
        }

        handleAsyncFunctions()
    }, [token, isTokenInStorage, isUserLoggedIn])

    return {
        appContainerStyle,
        isUserLoggedIn: isSkinSet ? isUserLoggedIn : false,
        analyticsMethods,
        analyticsLogEvent,
    }
}
